import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useStyles = makeStyles({
    iconContainer: {
        color: themeTokens.colorNeutralForegroundOnBrand,
        height: "50px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
    },
    menuItem: {
        ...shorthands.padding("5px", "15px")
    },
    fuiMenuItemRadiocheckmark: {
        display: "none"
    }
});
